// src/layout/MainLayout/MenuList/index.jsx (full fixed)
import { useMemo } from 'react'; // FIXED: Add useState import
import { useState } from 'react'; // NEW: Direct import for hooks
import PropTypes from 'prop-types';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Collapse, Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Dashboard as DashboardIcon,
  CalendarToday as CalendarIcon,
  Book as BookIcon,
  People as PeopleIcon,
  Rule as RuleIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import useAuth from 'hooks/useAuth';
import { Link } from 'react-router-dom';

const MenuList = ({ drawerOpen }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';

  // Memoized menu items with role filter
  const menuItems = useMemo(
    () => [
      { title: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard/default', roles: ['admin', 'user'] },
      { title: 'Bookings', icon: <CalendarIcon />, path: '/bookings', roles: ['admin', 'user'] },
      ...(isAdmin
        ? [
            { title: 'User Management', icon: <PeopleIcon />, path: '/admin/users', roles: ['admin'] },
            { title: 'Rules Management', icon: <RuleIcon />, path: '/admin/rules', roles: ['admin'] },
            { title: 'Spaces', icon: <BookIcon />, path: '/admin/spaces', roles: ['admin'] },
            { title: 'Settings', icon: <SettingsIcon />, path: '/admin/settings', roles: ['admin'] }
          ]
        : [])
    ],
    [isAdmin, user]
  );

  // FIXED: Direct useState (no React. prefix)
  const [openAdmin, setOpenAdmin] = useState(true); // Line ~39: Now crash-free

  return (
    <List
      component="nav"
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        borderRadius: 1,
        '& .MuiListItemButton-root': { borderRadius: 1, mx: 0.5, my: 0.25 }
      }}
      subheader={
        <Typography variant="h6" sx={{ p: 2, color: 'primary.main' }}>
          DK Studio
        </Typography>
      }
    >
      {menuItems
        .filter((item) => item.roles.includes(user?.role || 'user'))
        .map((item) => {
          const isAdminItem = item.roles.includes('admin') && !item.roles.includes('user');
          if (isAdminItem && !isAdmin) return null;

          return (
            <ListItemButton
              key={item.title}
              component={Link}
              to={item.path}
              selected={window.location.pathname.includes(item.path.split('/')[2] || '')}
              sx={{ ...(drawerOpen ? {} : { justifyContent: 'center' }) }}
            >
              <ListItemIcon sx={{ minWidth: drawerOpen ? 36 : 'auto', color: 'primary.main' }}>
                {item.icon}
              </ListItemIcon>
              {drawerOpen && <ListItemText primary={item.title} />}
            </ListItemButton>
          );
        })}
      {isAdmin && (
        <>
          <ListItemButton onClick={() => setOpenAdmin(!openAdmin)}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Admin Tools" />
            {openAdmin ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={openAdmin} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* Sub-items: Expand as needed */}
            </List>
          </Collapse>
        </>
      )}
    </List>
  );
};

MenuList.propTypes = {
  drawerOpen: PropTypes.bool
};

export default MenuList;